import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../../components/Common/TextInput';
import CallOut from '../../components/Common/CallOut';
import Notification from '../../components/Common/Notification';
import ActivityLoader from '../../components/Common/ActivityLoader';
import { useSchool } from '../../DataStore/SchoolContext';
import functions from '../../util/functions';
import { useStudent } from '../../DataStore/FeesStudentContext';
import ajaxSchool from '../../util/remote/ajaxSchool';
import { useTheme } from '../../DataStore/ThemeContext';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    group: '',
    loading: false,
}

const AssignFeesGroup = ({studentIds}) => {
    const {feesGroupListing, getFeesGroups} = useSchool();
    const {selectedIds} = useStudent();
    const [info, setInfo] = useState(null);
    const [state, dispatch] = useReducer(reducer, initialState);
    const {setSystemFunction} = useTheme();

    useEffect(()=>{
        setSystemFunction(() => async () => {
            await handleConfirm();
        });
        return () => setSystemFunction(null);
    }, [state]);

    useEffect(()=>{
        if(info){
            setTimeout(() => {
                setInfo(null);
            }, 5000);
        }
    }, [info]);

    const handleConfirm = async () =>{
       
        if(!state.group.value){
            setInfo(<Notification type='danger' message="Select fees group, then try again"/>);
            return;
        }

        const server_response = await ajaxSchool.assignFeesGroupSelection(state.group.value, studentIds ? studentIds : selectedIds);
        if(server_response.status==="OK"){
            setInfo(<Notification type='success' message={server_response.message} closable={false}/>);
        }else{
            setInfo(<Notification type='danger' message={server_response.message} closable={false}/>)
        }


    }




    const RenderOption = () => {

        const options = [];
        Array.isArray(feesGroupListing) && feesGroupListing.map((item) =>
            options.push({ label: item.group_name + '(' +  functions.numberFormat(item.amount) + ')', value: item.id })
        );
    
        return (
            <TextInput
                label="Choose Fees Group"
                type="select"
                leftIcon="fa fa-user-group"
                placeholder={state.group.label || 'Select fees group....'}
                options={options}
                onChange={(item) => dispatch({ type: 'group', value: item })}
                leftComponent={<i className="fa fa-user-group link" onClick={()=>getFeesGroups(true)}></i>}
                loading={!feesGroupListing}
                wrap
            />
        );
    };

    return (
        <>

            <CallOut 
                title="Assign Fees Group"
                description="Students can be assigned to fees groups for automatic billing, with group changes applied to all members."
             />
            <div className='mt-4'>{info}</div>
            <form className="form-horizontal" method="post" onSubmit={handleConfirm}>

                <RenderOption />

            
            </form> 

        </>
    );
};

export default AssignFeesGroup;